var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.infoTemplateComponent,{tag:"component",attrs:{"info":_vm.options.info[0]}})
}
var staticRenderFns = []

export { render, staticRenderFns }